import styled, { css } from 'styled-components';
import { Flex } from '../../Core';

const mobileDataTableItemStyles = css`
  width: 100%;
  height: 100%;
  padding: ${({ theme }) => theme.spacing8}px ${({ theme }) => theme.spacing16}px;
  cursor: pointer;
  user-select: none;
`;

function resolveMobileDataTableCardGap({
  $compact,
  $gap,
  theme,
}: {
  $compact?: boolean;
  $gap?: number | string;
  theme: { spacing4: number; spacing8: number };
}) {
  if (typeof $gap === 'number') {
    return `${$gap}px`;
  }

  if ($gap != null) {
    return $gap;
  }

  return `${$compact ? theme.spacing4 : theme.spacing8}px`;
}

export const MobileDataTableCardSurface = styled.button<{
  $background?: 'content' | 'inherit';
  $compact?: boolean;
  $gap?: number | string;
}>`
  ${mobileDataTableItemStyles}
  position: relative;
  display: flex;
  flex-direction: column;
  gap: ${resolveMobileDataTableCardGap};
  background: ${({ $background = 'content', theme }) =>
    $background === 'inherit' ? 'inherit' : theme.backgroundContent};
  border: 0;
  border-bottom: 2px solid ${({ theme }) => theme.backgroundDivider};
  text-align: left;
  color: ${({ theme }) => theme.colorTextDefault};

  &:active {
    background: ${({ theme }) => theme.colors.gray['010']};
  }
`;

export const MobileDataTableGroupCardSurface = styled(Flex)<{ expanded?: boolean }>`
  ${mobileDataTableItemStyles}
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: ${({ theme }) => theme.spacing12}px;
  background: inherit;
  border-bottom: ${({ expanded }) => (expanded ? '1px' : '2px')} solid ${({ theme }) => theme.backgroundDivider};
`;
